import React, { useEffect } from 'react';
import Divider from '@mui/joy/Divider';
import Checkbox from '@mui/joy/Checkbox';
import "./boxes.scss"
import { labelValue } from '../Helpers';
import { Button, Typography } from '@mui/joy';
import DynamicEditModal from '../DynamicComponents/DynamicEditModal';
import { toast } from 'react-toastify';
import { ApiService } from '../../api/ProjectInfoService';
import { Project } from '../../Objects/Project';
import { useState } from 'react';

interface Props {
    title: string;
    project: Project;
    userIsPrivileged: boolean;
}

const AlgemeenBox = ({ title, project, userIsPrivileged }: Props) => {
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);
  const [values, setValues] = useState<{ label: string; value: string , lang: string}[]>([]);
  useEffect(() => {
    setValues([
      { label: "Titel", value: project?.title, lang: "title" }
    ]);
  }, [])
  const handleOnClose = () => {
    setOpenEditModal(false);
  }

  const handleSave = (data: any) => {
            // map data to correct format
            const mappendata = {
              projectDospId: project.dospId,
              titel: data.find((item: any) => item.lang === "title") ? data.find((item: any) => item.lang === "title")?.value : project.title,  
            }
            console.log("mappendata", mappendata);
        
            ApiService.postProject(mappendata).then((res) => {
              toast.success("Project succesvol aangevraagd om aan te passen");
              setOpenEditModal(false);
            }
            ).catch((error : any) => {
              console.log(error);
              toast.error("Er is iets misgegaan bij het aanvragen om het project aan te passen");
            }
            );

    setOpenEditModal(false);
  }
    return (
      <div className="box">
                {userIsPrivileged && <DynamicEditModal
        isOpen={openEditModal}
        onClose={handleOnClose}
        onSave={handleSave}
        values={values}/>}
        <div className='headerLeden'>
        <h2>{title}</h2>
        {userIsPrivileged && <Button
          id="addButton"
          variant="outlined"
          color="neutral"
          sx={{ backgroundColor: "#484494" }}
          onClick={() => setOpenEditModal(true)}
        >
          Wijzig
        </Button>}
        </div>
        <div className="items">
          {labelValue(project?.title, "Titel")}
          {labelValue(project?.language, "Taal")}
          {labelValue(project?.dospId, "DOSP ID")}
          {labelValue(project?.projectStatus?.name, "Status")}
          {labelValue(project?.projectType?.name, "Type")}
          {labelValue(project?.acronym, "Acroniem")}
          {labelValue(project?.totalBudget ? "€ "+ project?.totalBudget: "" , "Totale Budget")}
          <div style={{ display: "flex"}}>
            <Typography level='title-sm'>BTW-plichtig:</Typography>
            <Checkbox
              className="checkbox"
              checked={project.vatLiable}
              variant="outlined"
              disabled
            />
          </div>
          <Divider />
          {labelValue(project?.websiteUrl, "Website")}
        </div>
      </div>
    );
};

export default AlgemeenBox;
